export default __webpack_public_path__ + "static/media/element_91.a52e2849.jpg";